// extracted by mini-css-extract-plugin
export default {"row":"CustomerItem-module__row--DtrXX","row-item":"CustomerItem-module__row-item--P23FJ","icon":"CustomerItem-module__icon--X8_Yz"};